import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const statusDotBase = theme => css`
  align-self: flex-start;
  flex-shrink: 0;
  margin: ${theme.spacing['3']};
`

const statusDot = theme => css`
  ${statusDotBase(theme)};
  margin-right: ${theme.spacing['5']};
`

const svgStatusDot = theme => css`
  ${statusDotBase(theme)};
`

const overlayLg = css`
  width: ${rem(240)};

  /* hide the enter icon from taking white space */
  .dropdown-menu-item-icon {
    display: none;
  }
`

const settingsItem = css`
  min-height: 0;
`

export const styles = {
  statusDot,
  svgStatusDot,
  overlayLg,
  settingsItem,
}
